import { Package, ChevronLeft, ChevronRight, ArrowUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import ProductCard from "./ProductCard";
import { generatePageNumbers } from "./shopData";

const SortBar = ({ sortBy, onSort, total }) => (
  <div className="flex items-center justify-between mb-4" data-testid="sort-bar">
    <span className="text-[#666] text-xs">{total.toLocaleString("nl-NL")} producten</span>
    <div className="flex items-center gap-2">
      <ArrowUpDown size={14} className="text-[#555]" />
      <select data-testid="sort-select" value={sortBy} onChange={(e) => onSort(e.target.value)}
        className="bg-[#111] border border-[#1E1E1E] text-white text-xs rounded-lg px-3 py-1.5 focus:border-[#FF3B30]/50 focus:outline-none cursor-pointer">
        <option value="name_asc">A → Z</option>
        <option value="name_desc">Z → A</option>
        <option value="price_asc">Prijs: laag → hoog</option>
        <option value="price_desc">Prijs: hoog → laag</option>
      </select>
    </div>
  </div>
);

export default function ProductGrid({ products, loading, onAdd, onView, page, totalPages, onPageChange, sortBy, onSort, total, onToggleWishlist, isInWishlist }) {
  if (loading) {
    return (
      <div className="text-center py-20">
        <div className="w-8 h-8 border-2 border-[#FF3B30] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#666] text-sm">Producten laden...</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-20">
        <Package size={48} className="text-[#1E1E1E] mx-auto mb-4" />
        <p className="text-[#666]">Geen producten gevonden</p>
      </div>
    );
  }

  return (
    <>
      {sortBy && onSort && <SortBar sortBy={sortBy} onSort={onSort} total={total || 0} />}
      <div data-testid="products-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
        {products.map((product) => (
          <ProductCard
            key={product.slug}
            product={product}
            onAdd={onAdd}
            onView={onView}
            onToggleWishlist={onToggleWishlist}
            inWishlist={isInWishlist ? isInWishlist(product.slug) : false}
          />
        ))}
      </div>
      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-3 mt-10">
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev"
            className="border-[#1E1E1E] text-[#888] hover:text-white bg-transparent rounded-lg">
            <ChevronLeft size={16} className="mr-1" /> Vorige
          </Button>
          <div className="flex items-center gap-1.5">
            {generatePageNumbers(page, totalPages).map((p, i) =>
              p === "..." ? (
                <span key={`dots-${i}`} className="text-[#555] px-1">...</span>
              ) : (
                <button key={p} data-testid={`pagination-page-${p}`} onClick={() => onPageChange(p)}
                  className={`w-9 h-9 rounded-lg text-xs font-semibold transition-all ${p === page ? "bg-[#FF3B30] text-white" : "bg-[#111] text-[#888] border border-[#1E1E1E] hover:text-white hover:border-[#FF3B30]/30"}`}>
                  {p}
                </button>
              )
            )}
          </div>
          <Button variant="outline" size="sm" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next"
            className="border-[#1E1E1E] text-[#888] hover:text-white bg-transparent rounded-lg">
            Volgende <ChevronRight size={16} className="ml-1" />
          </Button>
        </div>
      )}
    </>
  );
}
